import { render, staticRenderFns } from "./retail.vue?vue&type=template&id=20a8c502&scoped=true"
import script from "./retail.vue?vue&type=script&lang=js"
export * from "./retail.vue?vue&type=script&lang=js"
import style0 from "./retail.vue?vue&type=style&index=0&id=20a8c502&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8c502",
  null
  
)

export default component.exports